import React, { Component } from "react";

import FormsRow from "../components/FormsRow";
import TextInput from "../components/TextInput";
import PetrolDetailDataTable from "../petrol_form/PetrolDetailDataTable";
import FormApprovalInformationBox from "../../../Common/form_approval/InformationBox";
import EamPaymentApprovalInformation from "../../../Common/EamPaymentApprovalInformation";

import LoadingIndicator from "../../../Common/components/LoadingIndicator";
import DocumentList from "../../../Common/DocumentList";
import { petrolRequest } from "../../../../utils/apiRoutes";
import { getApi, getHeaders } from "../../../../utils/apiHelper";
import { main_url } from "../../../../utils/CommonFunction";
import apiRoutes from "../../../../utils/apiRoutes";

export default class PetrolView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      petrolDetails: [],
      documents: [],
      formApprovalParticipants: [],
      eamPaymentDetailsInfo: {},
    };
  }

  async componentDidMount() {
    const responseData = await this.getPetrolDetails();
    await this.getFormApprovalParticipants();
    this.getEamPaymentInfo();
    if (!!responseData && responseData.data) {
      const { details, documents } = responseData.data;
      this.setState({
        isLoading: false,
        petrolDetails: details,
        documents: documents,
      });
    }
  }

  getPetrolDetails = async () => {
    const { petrol_application_id } = this.props.petrolApplicationData;
    const res = await fetch(`${petrolRequest}/${petrol_application_id}`, {
      headers: getHeaders(),
    });
    if (res.ok) {
      return res.json();
    } else {
      this.setState({
        isLoading: false,
      });
      this.showError("Something went wrong... Couldn't load petrol details!");
      return null;
    }
  };

  async getFormApprovalParticipants() {
    const { petrol_application_id, form_no } = this.props.petrolApplicationData;

    const res = await getApi(
      apiRoutes.getFormApprovalParticipants(
        "petrol",
        petrol_application_id,
        form_no
      )
    );
    if (res) {
      this.setState({
        formApprovalParticipants: res.data,
      });
    }
  }

  getEamPaymentInfo() {
    const { form_no } = this.props.petrolApplicationData;

    let type = "Petrol";
    fetch(`${main_url}eam_payment/getEamPaymentInfo/${form_no}/${type}`, {
      headers: getHeaders(),
    })
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          eamPaymentDetailsInfo: res,
        });
      })
      .catch((error) => console.log(error));
  }

  showError = (message) => {
    this.props.showError(message);
  };

  render() {
    const petrolApplicationData = this.props.petrolApplicationData;

    const hasFetchedData =
      !this.state.isLoading && this.state.petrolDetails.length > 0;

    return (
      <div className="row white-bg">
        <div className="form-horizontal" name="demo-form">
          <div className="col-md-12" style={{ marginTop: 20 }}>
            <div className="ibox float-e-margins" id="add_check_form">
              <div className="ibox-content p-md">
                <FormsRow>
                  <TextInput
                    widthRatio={2}
                    label="Form Number"
                    value={`PR${petrolApplicationData.form_no}`}
                  />
                  <TextInput
                    widthRatio={2}
                    label="Request Date"
                    value={petrolApplicationData.request_date}
                  />
                  <TextInput
                    widthRatio={2}
                    label="Vehicle Type"
                    value={petrolApplicationData.vehicle_type_name}
                  />
                  <TextInput
                    widthRatio={2}
                    label="Plate Number"
                    value={petrolApplicationData.plate_number}
                  />
                  <TextInput
                    widthRatio={3}
                    label="Withdrawal Location"
                    value={petrolApplicationData.withdrawal_location_name}
                  />
                </FormsRow>
                <FormsRow
                  style={{
                    marginTop: 25,
                    paddingBottom: 35,
                    marginBottom: 35,
                    borderBottom: "solid 1px",
                  }}
                >
                  <TextInput
                    widthRatio={2}
                    label="Employee Name"
                    value={petrolApplicationData.fullname}
                  />
                  <TextInput
                    widthRatio={2}
                    label="Employee ID"
                    value={petrolApplicationData.employee_id}
                  />
                  <TextInput
                    widthRatio={2}
                    label="Position"
                    value={petrolApplicationData.position_name}
                  />
                  <TextInput
                    widthRatio={2}
                    label="Department"
                    value={petrolApplicationData.department_name}
                  />
                  <TextInput
                    widthRatio={2}
                    label="Branch"
                    value={petrolApplicationData.branch_name}
                  />
                  <TextInput
                    widthRatio={2}
                    label="Region"
                    value={petrolApplicationData.region_name}
                  />
                </FormsRow>

                {this.state.isLoading && (
                  <LoadingIndicator
                    marginTop={35}
                    marginBottom={35}
                    message="Loading Petrol Details..."
                  />
                )}
                {hasFetchedData && (
                  <PetrolDetailDataTable
                    petrolDetailsData={this.state.petrolDetails}
                    amountPerKm={petrolApplicationData.amountPerKm}
                    hideAction
                  />
                )}

                <FormsRow>
                  <div className="col-md-12 btn-rightend">
                    <TextInput
                      widthRatio={2}
                      label="Total Kilometer"
                      value={petrolApplicationData.total_km}
                      isNumber
                    />
                    <TextInput
                      widthRatio={2}
                      label="Total Amount"
                      value={petrolApplicationData.total_amount}
                      isNumber
                    />
                  </div>
                </FormsRow>

                <div className="row document-main">
                  {this.state.documents.length > 0 && (
                    <DocumentList
                      title="Petrol Document"
                      doc={this.state.documents}
                      path="api/v1/petrol/petrol-request"
                    />
                  )}
                </div>

                <div className="row approval-main margin-top-20">
                  <FormApprovalInformationBox
                    participantGroups={this.state.formApprovalParticipants}
                  />
                  {Object.values(this.state.eamPaymentDetailsInfo).length !==
                    0 && (
                    <EamPaymentApprovalInformation
                      eamPaymentDetailsInfo={this.state.eamPaymentDetailsInfo}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
